import { Injectable } from '@angular/core';

import { StatsigService } from '@services/statsig.service';

export enum ADMIN_FEATURE_FLAGS {
  ETT_VIEW_AND_EDIT_DRIVERS_LICENSE_INFO = 'ett-view-and-edit-drivers-license-info',
  ADMIN_V2_VEHICLE_SETTINGS_ENABLED = 'admin-v2-vehicle-settings-enabled',
  FORD_OEM_INTEGRATION = 'ford-oem-integration',
  HFT_GROUP_FILTER_IN_PAGE_HEADER_ENABLED = 'hft-group-filter-in-page-header-enabled',
  FE_DIRECTORY_SYNC_ENABLED = 'fe-ep-directory-sync-sso',
  VEHICLE_PROFILE_SETTINGS_OVERRIDES_ENABLED = 'vehicle-profile-settings-overrides-enabled',
  AT_DRIVER_WORKFLOW_AUTO_TEMPLATE_ENABLED = 'asset-tracking-driver-workflow-auto-template-enabled',
}

@Injectable({ providedIn: 'root' })
export class AdminFeatureFlagService {

  constructor(private statsigService: StatsigService) {}

  public isViewAndEditDriversLicenseInfoEnabled(): boolean {
    return this.statsigService
      .evaluateGate(ADMIN_FEATURE_FLAGS.ETT_VIEW_AND_EDIT_DRIVERS_LICENSE_INFO);
  }

  public isFordOEMEnabled(): boolean {
    return this.statsigService
      .evaluateGate(ADMIN_FEATURE_FLAGS.FORD_OEM_INTEGRATION);
  }

  public isAdminV2VehicleSettingsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(ADMIN_FEATURE_FLAGS.ADMIN_V2_VEHICLE_SETTINGS_ENABLED);
  }

  public isGroupFilterInNewHeaderEnabled(): boolean {
    return this.statsigService.evaluateGate(ADMIN_FEATURE_FLAGS.HFT_GROUP_FILTER_IN_PAGE_HEADER_ENABLED);
  }

  public isDirectorySyncEnabled(): boolean {
    return this.statsigService.evaluateGate(ADMIN_FEATURE_FLAGS.FE_DIRECTORY_SYNC_ENABLED);
  }

  public isVehicleProfileSettingsOverridesEnabled(): boolean {
    return this.statsigService.evaluateGate(ADMIN_FEATURE_FLAGS.VEHICLE_PROFILE_SETTINGS_OVERRIDES_ENABLED);
  }

  public isATDriverWorkflowAutoTemplateEnabled(): boolean {
    return this.statsigService.evaluateGate(ADMIN_FEATURE_FLAGS.AT_DRIVER_WORKFLOW_AUTO_TEMPLATE_ENABLED);
  }
}
